import { makeStyles, createStyles } from '@material-ui/core/styles'

import { Theme } from '~/theme/theme'

export const useCategoryQuantityTextStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        whiteSpace: 'nowrap'
      },
      title: {
        fontSize: 14,
        fontFamily: 'Prompt, sans-serif',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: theme.palette.text.primary,
        [theme.breakpoints.down('md')]: {
          fontSize: 16,
          fontFamily: 'Nunito Sans, sans-serif'
        }
      },
      count: {
        fontSize: 14,
        fontFamily: 'Prompt, sans-serif',
        fontWeight: 500,
        color: theme.palette.text.secondary,
        minWidth: '10px',
        textAlign: 'center',
        marginLeft: '4px'
      }
    }),
  { name: 'CategoryQuantityText' }
)
